import React, { memo } from 'react';
import { ListItemButton, ListItemText, Box, IconButton, ListItemIcon } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import MoreIcon from '@mui/icons-material/MoreVertRounded';
import WaveLayerIcon from './WaveLayerIcon';

const styles = theme => ({
    item: {
        background: theme.palette.action.hover,
    }
});

const WaveLayerHeader = memo(({
    title,
    open,
    onClick,
    advanced,
    onMoreClick,
    index,
    classes
}) => (
    <ListItemButton
        onClick={onClick}
        aria-expanded={open}
        sx={{ cursor: "pointer" }}
        className={open ? classes.item : null}
    >
        <ListItemIcon>
            <WaveLayerIcon index={index} />
        </ListItemIcon>
        <ListItemText>
            {title}
        </ListItemText>
        <Box>
            {advanced && (
                <IconButton
                    size='small'
                    aria-haspopup='true'
                    onClick={onMoreClick}
                    hidden={!advanced}
                >
                    <MoreIcon />
                </IconButton>
            )}
        </Box>
    </ListItemButton>
));

export default withStyles(WaveLayerHeader, styles);